import React, { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { resetPassword } from "../../features/store/authSlice";
import { Button } from "../Button";
import { Input } from "../Input";
import { NewPasswordFormProps } from "./types";

const NewPasswordForm: React.FC<NewPasswordFormProps> = ({
  isModal = false,
  onClose,
  onSuccess,
  email,
  token,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword] = useState(false);
  const [showConfirmPassword] = useState(false);

  const dispatch = useAppDispatch();

  const { loading, error } = useAppSelector((state) => state.auth);

  const validatePasswords = () => {
    if (password.length < 8) {
      return "Password must be at least 8 characters long";
    }
    if (password !== confirmPassword) {
      return "Passwords do not match";
    }
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationError = validatePasswords();
    if (validationError) {
      // You might want to set a local error state here
      return;
    }

    try {
      await dispatch(
        resetPassword({
          email,
          token,
          password,
          password_confirmation: confirmPassword,
        })
      ).unwrap();

      // On success
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Password reset failed:", error);
    }
  };

  const validationError = validatePasswords();

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative">
        <Input type="text" placeholder="Email" value={email} disabled />
      </div>

      <div className="relative">
        <Input
          type={showPassword ? "text" : "password"}
          placeholder="New Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <div className="relative">
        <Input
          type={showConfirmPassword ? "text" : "password"}
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          disabled={loading}
        />
      </div>

      {validationError && (
        <div className="text-red-500 text-sm text-center">
          {validationError}
        </div>
      )}

      {/* API Error */}
      {error && <div className="text-red-500 text-sm text-center">{error}</div>}

      <Button
        type="submit"
        bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
        textColor="text-white"
        className="w-full h-12"
        borderRadius="rounded-lg"
        disabled={loading || !!validationError || !password || !confirmPassword}
      >
        {loading ? "Resetting Password..." : "Reset Password"}
      </Button>
    </form>
  );
};

export default NewPasswordForm;
